export default {
    message: "Os itens listados abaixo estão esgotados e foram removidos do seu carrinho. Por favor, faça seleções diferentes.",
    buttons: {
        ok: "OK"
    }
}